<template>
	<component
		:is="setup.targetDashboard"
		v-if="setup.targetDashboard"/>
</template>

<script setup lang="ts">
import DashboardViewSetupService from '@/setup/dashboard/DashboardViewSetupService';
const props = defineProps(DashboardViewSetupService.props);
const setup = new DashboardViewSetupService(props);
</script>
